
import TypoGraph from "../forms/typograph";
import React, {useEffect} from "react";
import logo1 from "../../styles/images/menuIcons/logo.svg";
import "./ConfirmationEmailPage.scss";

const ConfirmationEmailPage = (props) => {
    const {title,paragraph} = props

    useEffect(() => {
        localStorage.removeItem("redirectUrl")
    },[])

    return (
        <div className="confirm-email-page">
            <div className="confirmation-card">
                <img src={logo1} style={{width: '130px'}} alt="rox logo" className="position-relative mt-2"/>
                <h4>{title}</h4>
                <p className={"mb-4"}>
                    {paragraph}
                </p>
                <TypoGraph
                    variant="body2"
                    content={'Go back to the login'}
                    className={"back-to-login-button"}
                    onClick={() => {
                       props.redirectToLogin()
                    }}
                />
            </div>
        </div>
    )
}

export default ConfirmationEmailPage;